import styled from 'styled-components';

export const StyledUserContainer = styled.div`
  display: flex;
  gap: 2.4rem;
  flex-direction: column;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    flex-direction: row;
  }
`;

export const StyledLeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 30.6rem;
  padding: 3.2rem 3.2rem 4.6rem 3.2rem;
  background-color: ${({ theme }) => theme.colors.background.main};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  border-radius: ${({ theme }) => theme.radius.small};
  height: fit-content;
  flex-wrap: wrap;
`;

export const StyledAvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: 1.6rem;
`;

export const StyledTagsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    width: 100%;
    max-height: 30.4rem;
    flex-wrap: wrap;
    column-gap: 2.4rem;
    align-content: center;
    padding-inline: 2.4rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    width: 100%;
    flex-wrap: unset;
    column-gap: 0;
    align-content: center;
    padding-inline: 0;
    max-height: unset;
  }
`;

export const StyledDivider = styled.div`
  height: 1.2rem;
`;

export const StyledUsername = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.sizes.default};
  line-height: 1.6rem;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledAvatar = styled.img`
  width: 6.4rem;
  height: 6.4rem;
  border-radius: 100%;
  object-fit: cover;
  background: ${({ theme }) => theme.colors.black};
`;

export const StyledRightContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2.4rem;
`;

export const StyledTitle = styled.p`
  font-size: 1.8rem;
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
  color: ${({ theme }) => theme.colors.text.main};
`;
